<template>
    <template v-if="type === 'pointHead'">
        <div class="xian"></div>
        <div class="point-content">
            <img
                :src="pointSvg"
                alt=""
                class="icon"
            />
            <span v-if="info.total !== ''">{{$t('design.point.pointNum', { point: info.total })}}</span>
        </div>
    </template>
    <div class="point-info" :style="{ width: `${width}px`, height: 'auto !important'}" ref="cardRef" v-show="type === 'pointCard' ">
        <div class="top">
            <div class="title">
                <span class="txt1">{{$t('design.point.available')}}：{{$t('design.point.pointNum', { point: info.total })}}</span>
                <span class="txt2" @click="onGoRule">{{$t('design.pointCard.rule') || '规则'}}<i></i></span>
            </div>
            <div class="store-card">
                <span class="tlt"><i></i>{{$t('design.pointCard.debit') || '储值卡'}}：</span>
                <span>{{$t('design.point.pointNum', { point: info.debitPoint })}}</span>
            </div>
            <div class="gift-card">
                <span class="tlt"><i></i>{{$t('design.pointCard.gift') || '礼品卡'}}：</span>
                <span>{{$t('design.point.pointNum', { point: info.giftPoint })}}</span>
            </div>
        </div>
        <div class="footer" v-if="isAdmin === 'y' || platform === 'designerService'">
            <xl-button type="primary" @click="onDetail">{{$t('design.pointCard.goDetail') || '查看详情'}}</xl-button>
            <div class="tip" v-if="info.expiredPoint"><i></i><span>{{$t('design.pointCard.expiredTip', { point: info.expiredPoint })}}</span></div>
        </div>
    </div>
</template>

<script setup>
import { XlButton, XlLoading } from '@shining3d/ui-components';
import { VueCookieNext } from 'vue-cookie-next';
import { ref, computed, onMounted, onBeforeUnmount, defineEmits, nextTick, defineProps, defineExpose } from 'vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang("@shining3d/xl-design-order");
import _get from 'lodash/get';
import Api from '../api/creditCard';
import { useStore } from "vuex";
import router from "@/router";
import Bus from '../utils/bus';
import pointSvg from '../assets/image/point.svg';

const $store = useStore();

const lang = ref(VueCookieNext.getCookie("lang"));
const isAdmin = computed(() => _get( $store, 'state.factorySelect.isAdmin', ''));

const width = computed(() => {
    const map = {
        "zh-cn": 234,
        "en-us": 304,
        "ja-jp": 330
    };
    return map[lang.value] || 304;
});
const height = computed(() => (isAdmin.value !== 'y' ? 136 : (lang.value === "zh-cn" ? 214 : 232)));

const props = defineProps({
    type: {
        type: String,
        default: 'pointCard'
    },
    platform: {
        type: String,
        default: 'dental' // dental:齿科云 designerService: 设计师接单平台
    }
});

const emits = defineEmits(['close', 'resize']);
// 机构id
const institutionId = computed(() => {
    let id = _get( $store, 'state.factorySelect.id', '');
    if ( props.platform === 'designerService') {
        id = _get( $store, 'state.factoryID', '');
    }
    return id;
});

const info = ref({
    total: '',
    giftPoint: 0,
    debitPoint: 0,
    expiredPoint: 0
});

const cardRef = ref();
const loadingInstance = ref(null);
const getPointInfo = () => {
    if ( loadingInstance.value ) {
		loadingInstance.value?.close();
	}
    if ( props.type === 'pointCard' ) {
        loadingInstance.value = XlLoading.service({
            target: cardRef.value,
            background: 'rgba(255,255,255,0.99)',
        });
    }
    Api.getPoint({
        factoryID: institutionId.value
    }).then((res) => {
        if (res && res.status === 'success') {
            info.value = res.result || {};

            if ( props.type === 'pointCard' ) {
                Bus.$emit('updatePointsWithNum', info.value.total );
            }
        }
        // let height = '';
        // if ( isAdmin.value !== 'y' ) {
        //     height = 136;
        // } else {
        //     if ( info.expiredPoint) {
        //         height = lang.value === "zh-cn" ? 214 : 232;
        //     } else {
        //         height = 184;
        //     }
        // }
        // height.value = height;
        nextTick(() => {
            emits('resize');
            loadingInstance.value?.close();
        });
    }).catch(() => {
        loadingInstance.value?.close();
    });
    
};

const onDetail = () => {
    // router.replace({
    //     name: 'institutionSetting',
    //     params: {
    //         id: institutionId.value,
    //         target: 'payment'
    //     },
    //     query: {
    //         type: 'point'
    //     }
    // });
    // emits('close');
    let url = `/u/institution-setting/${institutionId.value}/payment?paymentType=point`;
    if ( props.platform === 'designerService' ) {
        url = `/org?type=payInfo&paymentType=point`;
    }
    window.location.href = url;
};

const onGoRule = () => {
    let ruleUrl = '';
    if ( lang.value === "zh-cn" ) {
        // 中文网址
        ruleUrl = 'https://docs.shining3d.com/dentalcloud/latest/zh-cn/faq/credits/';
    } else {
        // 英文网址
        ruleUrl = 'https://docs.shining3d.com/dentalcloud/latest/en-us/faq/credits/';
    }
    if ( ruleUrl ) {
        window.open(ruleUrl,"_blank" )
    }
};

const updatePointTotal = ( val ) => {
    info.value.total = val;
};

onMounted(() => {
    if ( props.type === 'pointHead' ) {
        Bus.$on('updatePoints', getPointInfo);
        Bus.$on('updatePointsWithNum', updatePointTotal);
    }
    getPointInfo();
});

onBeforeUnmount(() => {
    if( props.type === 'pointHead' ) {
        Bus.$off('updatePoints', getPointInfo);
        Bus.$off('updatePointsWithNum', updatePointTotal);
    }
});

defineExpose({ getPointInfo })
</script>

<style lang="scss" scoped>
.point-info {
    padding: 16px;
    width: 234px;
    height: 214px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .top {
        flex: 1;
    }
    .title {
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .txt1 {
            font-weight: 700;
            color: #2C364E;
        }
        .txt2 {
            font-size: 12px;
            color: #5587FF;
            font-weight: 400;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            i {
                display: inline-block;
                margin-left: 4px;
                width: 14px;
                height: 14px;
                background-size: contain;
                background-image: url('../assets/image/pointRule.svg');
            }
        }
    }
    .store-card,
    .gift-card {
        height: 28px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #42526E;
        .tlt {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        i {
            display: inline-block;
            margin-right: 4px;
            width: 16px;
            height: 16px;
            background-size: contain;
        }
    }
    .store-card {
        margin-top: 17px;
        background: linear-gradient(90deg, rgba(237, 243, 255, 0.1) 0%, #EDF3FF 50%, rgba(237, 243, 255, 0.1) 100%);
        i {
            background: url('../assets/image/pointStore.svg');
        }
    }
    .gift-card {
        margin-top: 8px;
        // margin-bottom: 20px;
        background: linear-gradient(90deg, rgba(231, 249, 243, 0.1) 0%, #E7F9F3 50%, rgba(231, 249, 243, 0.1) 100%);
        i {
            background: url('../assets/image/pointGift.svg');
        }
    }
    :deep(.xl-button) {
        margin-top: 20px;
        width: 100%;
    }
    .tip {
        margin-top: 8px;
        font-size: 14px;
        color: #737E99;
        display: flex;
        align-items: center;

        i {
            flex-shrink: 0;
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-right: 4px;
            background: url('../assets/image/pointTrumpet.svg');
        }
    }
}
.xian{
    width: 1px;
    height: 39%;
    position: relative;
    left: -16px;
    background: #E0E4EA;
}
.point-content {
    min-width: 70px;
    box-sizing: border-box;
    padding-right: 12px;
    height: 28px;
    line-height: 28px;
    background: #DFE9FF;
    font-size: 14px;
    font-weight: 500;
    color: #5587FF;
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    font-family: $font-family65;
    .icon {
        width: 28px;
        height: 28px;
        padding-right: 3px;
    }
}
</style>